module.exports = __webpack_public_path__ + "e8fb28c5ad2cd6fbf6635bf51da262fd.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sharing-center/shared-folders/manage/edit/edit-shared-folder.html
// module id = 1815
// module chunks = 0